import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import { Form, Button, FormGroup, FormControl, ControlLabel, Col, Row, InputGroup } from "react-bootstrap";
// import useForm from 'react-hook-form'

import { config } from '../../../../../config/index'
import LayoutContext from '../../../../../store/Layout/contexts'
import { PUT, newFetch } from '../../../../../helpers/fetch'
import ToastUtil from "../../../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../../../components/SweetAlert";
const { API_URL } = config

const EditSupervisor = ({ history, match: { params } }) => {
  // const { handleSubmit, register, errors } = useForm()
  const token = localStorage.getItem('token')
  const supervisor_id = parseInt(params.supervisor_id)

  const [clients, setClients] = useState([])
  const [sites, setSites] = useState([])
  const [supervisor, setSupervisor] = useState({})

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [employeeNo, setEmployeeNo] = useState('')
  const [employeeID, setEmployeeID] = useState('')
  const [gender, setGender] = useState(0)
  const [race, setRace] = useState(0)
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNo, setPhoneNo] = useState('')

  const firstNameHandler = e => setFirstName(e.target.value)
  const lastNameHandler = e => setLastName(e.target.value)
  const employeeNoHandler = e => setEmployeeNo(e.target.value)
  const employeeIDHandler = e => setEmployeeID(e.target.value)
  const genderHandler = e => setGender(e.target.value)
  const raceHandler = e => setRace(e.target.value)
  const dateOfBirthHandler = e => setDateOfBirth(e.target.value)
  const emailHandler = e => setEmail(e.target.value)
  const phoneNoHandler = e => setPhoneNo(e.target.value)

  const [validated, setValidated] = useState(false);

  const [activeClient, setActiveClient] = useState(null)
  const [activeSites, setActiveSites] = useState([])

  const [siteSupervisors, setSiteSupervisors] = useState([])
  const [oldSiteSupervisors, setOldSiteSupervisors] = useState([])
  const [newSiteSupervisors, setNewSiteSupervisors] = useState([])

  const clientHandler = async e => {
    if (
      await AlertService.confirm("", "Assigning this Supervisor to a new Client will reset this Supervisor's assigned Sites. Are you sure you want to proceed?")
    ) {
      setActiveClient(
        [...clients].find(client => client.id === parseInt(e.target.value))
      )
      setActiveSites(
        [...sites].filter(site => site.client_id === parseInt())
      )
      setNewSiteSupervisors([])
    } else {
      e.preventDefault()
    }
  }

  const siteHandler = e => {
    const pickedSite = JSON.parse(e.target.value)
    if (!siteSupervisors.some(siteAssociate => siteAssociate.site_id === parseInt(pickedSite.id))) {
      addSiteSupervisor(pickedSite.id, pickedSite.name)
    }
  }

  const addSiteSupervisor = (id, name) => {
    if (!oldSiteSupervisors.some(siteSupervisor => siteSupervisor.id === id)
      && !newSiteSupervisors.some(siteSupervisor => siteSupervisor.id === id)) {
      setNewSiteSupervisors([
        ...newSiteSupervisors,
        {
          // name,
          site_id: id,
          start_date: null,
          resign_date: null,
          last_day_date: null
        }
      ])
    }
  }

  const removeSiteSupervisor = index =>
    setNewSiteSupervisors(
      [...newSiteSupervisors].filter((siteSupervisor, i) => i !== index)
    )

  const oldStartDateHandler = (index, e) => {
    siteSupervisorsArr[index].start_date = e.target.value
    let siteSupervisorsArr = [...oldSiteSupervisors]
    setOldSiteSupervisors(siteSupervisorsArr)
  }

  const oldResignDateHandler = (index, e) => {
    let siteSupervisorsArr = [...oldSiteSupervisors]
    siteSupervisorsArr[index].resign_date = e.target.value
    setOldSiteSupervisors(siteSupervisorsArr)
  }

  const oldLastDayDateHandler = (index, e) => {
    let siteSupervisorsArr = [...oldSiteSupervisors]
    siteSupervisorsArr[index].last_day_date = e.target.value
    setOldSiteSupervisors(siteSupervisorsArr)
  }

  const newStartDateHandler = (index, e) => {
    let siteSupervisorsArr = [...newSiteSupervisors]
    siteSupervisorsArr[index].start_date = e.target.value
    setNewSiteSupervisors(siteSupervisorsArr)
  }

  const newResignDateHandler = (index, e) => {
    let siteSupervisorsArr = [...newSiteSupervisors]
    siteSupervisorsArr[index].resign_date = e.target.value
    setNewSiteSupervisors(siteSupervisorsArr)
  }

  const newLastDayDateHandler = (index, e) => {
    let siteSupervisorsArr = [...newSiteSupervisors]
    siteSupervisorsArr[index].last_day_date = e.target.value
    setNewSiteSupervisors(siteSupervisorsArr)
  }

  const fetchClients = async () => {
    try {
      let url = `${API_URL}/client`

      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8'
        }
      })

      if (response.ok) {
        let data = await response.json()

        const clientData = data.data
        setClients(clientData)
      } else {
        console.log(response.message)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSites = async () => {
    const url = `${API_URL}/sites`
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8'
        }
      })

      let json = await response.json()

      if (response.ok) {
        setSites(json.data)
      } else {
        ToastUtil.error('Sites is not available')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSupervisor = async () => {
    try {
      let url = `${API_URL}/supervisor/${supervisor_id}`

      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8'
        }
      })

      if (response.ok) {
        let data = await response.json()

        const supervisorData = data.data
        setSupervisor(supervisorData)
        setFirstName(supervisorData.first_name)
        setLastName(supervisorData.last_name)
        setEmployeeNo(supervisorData.employee_no)
        setEmployeeID(supervisorData.employee_id)
        setGender(supervisorData.gender_id)
        setRace(supervisorData.race_id)
        setDateOfBirth(supervisorData.date_of_birth)
        setEmail(supervisorData.email)
        setPhoneNo(supervisorData.phone_no)
        setActiveClient(supervisorData.client)
        setSiteSupervisors(supervisorData.sites)
        setOldSiteSupervisors(JSON.parse(JSON.stringify(supervisorData.sites)))
      } else {
        console.log(response.message)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  useEffect(() => {
    if (activeClient) {
      const sitesActive = [...sites].filter(
        site => site.client_id === activeClient.id
      )
      setActiveSites(sitesActive)
    }
  }, [activeClient, sites])

  const discardHandler = async() => {
    if (await AlertService.confirm("", "Are you sure you want to discard all changes?")) {
      setFirstName(supervisor.first_name)
      setLastName(supervisor.last_name)
      setEmployeeID(supervisor.employee_id)
      setEmployeeNo(supervisor.employee_no)
      setGender(supervisor.gender_id)
      setRace(supervisor.race_id)
      setDateOfBirth(supervisor.date_of_birth)
      setEmail(supervisor.email)
      setPhoneNo(supervisor.phone_no)
      setActiveClient(supervisor.client)
      setSiteSupervisors(supervisor.sites)
      setOldSiteSupervisors(JSON.parse(JSON.stringify(supervisor.sites)))
      setNewSiteSupervisors([])
    }
  }

  const deactivateSupervisorHandler = async id => {
    if (await AlertService.confirm("", "Are you sure you want to deactivate this admin?")) {
      let api_path = `/supervisor/${id}/activation/deactivate`
      let response = await newFetch(PUT, api_path)
      ToastUtil.success(response.message)
      response.success && history.push(`/supervisors`)
    }
  }

  const activateSupervisorHandler = async id => {
    if (await AlertService.confirm("", "Are you sure you want to activate this admin?")) {
      let api_path = `/supervisor/${id}/activation/activate`
      let response = await newFetch(PUT, api_path)
      ToastUtil.success(response.message)
      response.success && history.push(`/supervisors`)
    }
  }

  const submitSupervisorHandler = async () => {
    const data = {
      first_name: firstName,
      last_name: lastName,
      employee_id: employeeID,
      employee_no: employeeNo,
      gender_id: gender,
      race_id: race,
      date_of_birth: dateOfBirth,
      email,
      phone_no: phoneNo
    }

    const url = `${API_URL}/supervisor/${supervisor_id}/update`

    try {
      return await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const submitOldSiteSupervisorsHandler = async () => {
    await oldSiteSupervisors.map(async siteSupervisor => {
      let url = `${API_URL}/supervisor/${supervisor_id}/site/${siteSupervisor.id}/dates`

      try {
        let data = {
          start_date: siteSupervisor.start_date,
          resign_date: siteSupervisor.resign_date,
          last_day_date: siteSupervisor.last_day_date
        }

        return await fetch(url, {
          method: 'PUT',
          body: JSON.stringify(data),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8'
          }
        })
      } catch (error) {
        console.log(error)
      }
    })

    return true
  }

  const submitNewSiteSupervisorHandler = async () => {
    const url = `${API_URL}/supervisor/${supervisor_id}/assignsite`

    try {
      const siteSupervisorsArr = [...newSiteSupervisors]

      return await fetch(url, {
        method: 'POST',
        body: JSON.stringify({ sites: siteSupervisorsArr }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const submitHandler = async e => {
    e.preventDefault()

    // if (firstName && lastName && employeeNo && email) {
    if (await AlertService.confirm("", "Are you sure you want to update this Supervisor?")) {
      let supervisor_response = await submitSupervisorHandler()
      let supervisor_data = await supervisor_response.json()

      if (supervisor_response.ok) {
        let old_sites_response = await submitOldSiteSupervisorsHandler()

        if (newSiteSupervisors.length > 0) {
          let new_sites_response = await submitNewSiteSupervisorHandler()
          let new_sites_data = await new_sites_response.json()

          if (new_sites_response.ok) {
            ToastUtil.success('Supervisor has been updated successfully!')
            window.location.replace(
              `${window.location.origin}/supervisors/supervisor/${supervisor_id}`
            )
          } else {
            ToastUtil.error('Failed to assign new sites to Supervisor!')
          }
        } else {
          ToastUtil.success('Supervisor has been updated successfully!')
          window.location.replace(
            `${window.location.origin}/supervisors/supervisor/${supervisor_id}`
          )
        }
      } else {
        ToastUtil.error('Failed to update Supervisor!')
      }
    }
    // } else {
    //   ToastUtil.error('Please input all required fields!')
    // }
  }

  const getSiteNameById = id => {
    const siteConst = sites.find(site => site.id === id)
    if (siteConst) return siteConst.name
  }

  const init = async () => {
    fetchClients()
    fetchSites()
    fetchSupervisor()
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to={`/supervisors/supervisor/${supervisor_id}`}
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div>
                <i className="fas fa-chevron-left pe-2"></i>{' '}
                {supervisor.first_name} {supervisor.last_name}
              </div>
            </NavLink>
            <div className="pt-4">
              <h3>Edit Supervisor</h3>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="border rounded d-flex" style={{ marginTop: '2rem', marginLeft: '3rem', marginRight: '3rem' }}>
              <div style={{ minWidth: '15rem', width: '15rem', backgroundColor: '#f3f3f3', padding: '2.25rem' }} className="border-right">
                <strong>Supervisor Information</strong>
                <p className="pt-2 text-muted">View and edit supervisor information</p>
              </div>
              <div className="flex-grow-1 bg-white" style={{ padding: '2.25rem' }}>
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>First Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      value={firstName}
                      placeholder="First name"
                      onChange={(e) => firstNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter first name.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>Last Name*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      value={lastName}
                      type="text"
                      placeholder="Last name"
                      onChange={(e) => lastNameHandler(e)}
                      maxLength={60}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee No*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      value={employeeNo}
                      type="text"
                      placeholder="Employee No"
                      onChange={(e) => employeeNoHandler(e)}
                      maxLength={12}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee no.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Employee ID</strong>
                    </Form.Label>
                    <Form.Control
                      value={employeeID}
                      type="text"
                      placeholder="Employee ID"
                      onChange={(e) => employeeIDHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter employee id.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="4">
                    <strong>Gender</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => genderHandler(e)}
                      value={gender}
                    >
                      <option value="">Select Gender</option>
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a race.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <strong>Race</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      onChange={(e) => raceHandler(e)}
                      value={race}
                    >
                      <option value="">Select Race</option>
                      <option value="1">Chinese</option>
                      <option value="2">Malay</option>
                      <option value="3">Indian</option>
                      <option value="4">Others</option>
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      Please select a race.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <strong>Date Of Birth</strong>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      placeholder="Date Of Birth"
                      value={dateOfBirth}
                      onChange={(e) => dateOfBirthHandler(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter date of birth.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Email*</strong>
                    </Form.Label>
                    <Form.Control
                      disabled
                      value={email}
                      type="email"
                      placeholder="Email"
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter valid email.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Phone No</strong>
                    </Form.Label>
                    <Form.Control
                      value={phoneNo}
                      type="text"
                      placeholder="Phone Number"
                      onChange={(e) => phoneNoHandler(e)}
                      maxLength={20}
                    />
                  </Form.Group>
                </Row>
              </div>
            </div>
            <div className="border rounded d-flex" style={{ marginTop: '2rem', marginLeft: '3rem', marginRight: '3rem', marginBottom: '6rem' }}>
              <div style={{ minWidth: '15rem', width: '15rem', backgroundColor: '#f3f3f3', padding: '2.25rem' }} className="border-right">
                <strong>Assigned To</strong>
                <p className="pt-2 text-muted">Manage client and site assignation</p>
              </div>
              <div className="flex-grow-1 bg-white" style={{ padding: '2.25rem' }}>
                <Row>
                  <Form.Group as={Col} md="12">
                    <strong>Client*</strong>
                    <Form.Control
                      as="select"
                      required
                      type="select"
                      value={activeClient && activeClient.id}
                      onChange={(e) => clientHandler(e)}
                    >
                      {clients &&
                        clients.map((client) => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <strong>Add Sites</strong>
                    <Form.Control
                      as="select"
                      type="select"
                      value=""
                      onChange={siteHandler}
                    >
                      <option value="" disabled>Select Site</option>
                      {activeClient &&
                        sites
                          .filter(site => site.active === true)
                          .map(
                            site =>
                              site.client_id === activeClient.id && (
                                <option key={site.id} value={JSON.stringify(site)}>
                                  {site.name}
                                </option>
                              )
                          )}
                    </Form.Control>
                  </Form.Group>
                  <div className="col-sm-12">
                    {oldSiteSupervisors &&
                      oldSiteSupervisors.map((siteSupervisor, index) => (
                        <div key={siteSupervisor.id} className="pt-3">
                          <div className="d-flex justify-content-start">
                            <strong>
                              {getSiteNameById(siteSupervisor.id)}
                            </strong>
                          </div>
                          <div
                            className="border rounded mt-2"
                            style={{ padding: '2.25rem' }}
                          >
                            <Row>
                              <Form.Group as={Col} md="6">
                                <strong>Start Date*</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.start_date}
                                  onChange={(e) => oldStartDateHandler(index, e)}
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please enter start date.
                                </Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group as={Col} md="6">
                                <strong>Resign Date</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.resign_date}
                                  onChange={(e) => oldResignDateHandler(index, e)}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md="6">
                                <strong>Last Day Date</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.last_day_date}
                                  onChange={(e) => oldLastDayDateHandler(index, e)}
                                />
                              </Form.Group>
                            </Row>
                          </div>
                        </div>
                      ))}
                    {newSiteSupervisors &&
                      newSiteSupervisors.map((siteSupervisor, index) => (
                        <div key={siteSupervisor.id} className="pt-3">
                          <div className="d-flex justify-content-between">
                            <strong>
                              {getSiteNameById(siteSupervisor.site_id)}
                            </strong>
                            <p
                              style={{ cursor: 'pointer' }}
                              className="text-danger"
                              onClick={() => removeSiteSupervisor(index)}
                            >
                              Remove
                            </p>
                          </div>
                          <div
                            className="border rounded mt-2"
                            style={{ padding: '2.25rem' }}
                          >
                            <Row>
                              <Form.Group as={Col} md="6">
                                <strong>Start Date*</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.start_date}
                                  onChange={(e) => newStartDateHandler(index, e)}
                                  required
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please enter start date.
                                </Form.Control.Feedback>
                              </Form.Group>
                              <Form.Group as={Col} md="6">
                                <strong>Resign Date</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.resign_date}
                                  onChange={(e) => newResignDateHandler(index, e)}
                                />
                              </Form.Group>
                              <Form.Group as={Col} md="6">
                                <strong>Last Day Date</strong>
                                <Form.Control
                                  type="date"
                                  value={siteSupervisor.last_day_date}
                                  onChange={(e) => newLastDayDateHandler(index, e)}
                                />
                              </Form.Group>
                            </Row>
                          </div>
                        </div>
                      ))}
                  </div>
                </Row>
              </div>
            </div>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem'
              }}
              className="border-top bg-white d-flex justify-content-between align-items-center"
            >

              {supervisor.active ? (
                <button
                  type="button"
                  onClick={() => deactivateSupervisorHandler(supervisor.id)}
                  className="btn btn-outline-danger align-items-start"
                  style={{ width: '12rem' }}
                >
                  Deactivate Supervisor
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => activateSupervisorHandler(supervisor.id)}
                  className="btn btn-outline-success align-items-start"
                  style={{ width: '12rem' }}
                >
                  Activate Supervisor
                </button>
              )}

              <div className="d-flex">
                <button
                  type="button"
                  onClick={discardHandler}
                  className="btn btn-outline-brand"
                  style={{ width: '12rem' }}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  )
}

export default EditSupervisor
